"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const next13_enums_colors_1 = __importDefault(require("@gerenciatd/next13.enums.colors"));
const LinkedInIconM = (props) => {
    let { color } = props;
    let layoutSize = {};
    if (props.layoutSize) {
        ({ layoutSize } = props);
    }
    let { width, height, insetPosition } = props;
    const size = {};
    /* damos valor a la otra coordenada en caso de no indicarse */
    if (width && width !== 'auto') {
        if (!layoutSize.width) {
            layoutSize.width = width;
        }
        size.width = width;
    }
    if (height && height !== 'auto') {
        if (!layoutSize.height) {
            layoutSize.height = height;
        }
        size.height = height;
    }
    const fill = (0, next13_enums_colors_1.default)(color);
    return (react_1.default.createElement("div", { className: "svg-layout-size", style: Object.assign({}, layoutSize) },
        react_1.default.createElement("svg", Object.assign({ focusable: "false", viewBox: "-0.5 -0.5 18 18", "aria-label": true, "aria-hidden": "true", role: "presentation" }, size, { style: Object.assign({}, insetPosition), fill: fill }),
            react_1.default.createElement("path", { d: "M6.152,7.927V18.906H2.5V7.927Zm.233-3.39a1.754,1.754,0,0,1-.56,1.352,2.088,2.088,0,0,1-1.5.543H4.3a2,2,0,0,1-1.462-.543,1.816,1.816,0,0,1-.554-1.352,1.786,1.786,0,0,1,.571-1.357,2.082,2.082,0,0,1,1.49-.537,2.03,2.03,0,0,1,1.473.537,1.847,1.847,0,0,1,.565,1.357ZM19.3,12.613v6.293H15.657V13.034a3.207,3.207,0,0,0-.449-1.823,1.575,1.575,0,0,0-1.4-.659,1.8,1.8,0,0,0-1.169.382,2.355,2.355,0,0,0-.7.947,2.684,2.684,0,0,0-.122.9V18.9H8.168q.022-4.42.022-7.168T8.179,8.458l-.011-.532h3.645v1.6h-.022a4.841,4.841,0,0,1,.454-.62,4.71,4.71,0,0,1,.626-.576,2.88,2.88,0,0,1,.964-.482A4.391,4.391,0,0,1,15.1,7.67,3.935,3.935,0,0,1,18.15,8.928,5.276,5.276,0,0,1,19.3,12.612Z", transform: "translate(-2.285 -2.642)" }))));
};
exports.default = LinkedInIconM;
//# sourceMappingURL=index.js.map